/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
//TODO make the paths dynamic like nuxt

// const ApplicationAdd = () => { import('../pages/application/add.vue')}
// const ApplicationEdit = () => { import('../pages/application/edit.vue')}
export default [
  {
    path: '/home',
    redirect: '/',
  },
  {
    path: '/home/dashboard',
    view: 'home/dashboard',
  },
  {
    path: '/application/bankidverify',
    view: 'application/bankidverify/index',
  },
  {
    path:'/quote/edit/:quote_id',
    view:'application/edit',
    name: 'QuoteEdit',
    children: [
      {
        path: 'business',
        view: 'application/business/index',
        children: [
          {
            path: 'products',
            name: 'Equipments',
            view: 'application/equipment_pricing/equipments',
          },
          {
            path: 'pricing',
            name: 'Pricing',
            view: 'application/equipment_pricing/pricing',
          },
          {
            path: '',
            name: 'BusinessInfo',
            view: 'application/business/business_info',
          },
        ]
      },
    ]
  },
  {
    path: '/quote/view/:quote_id',
    view: 'application/view',
    name: 'QuoteView',
    children: [
      {
        path: 'business',
        view: 'application/business/index',
        children: [
          {
            path: 'products',
            name: 'ViewEquipments',
            view: 'application/equipment_pricing/view_equipments',
          },
          {
            path: 'pricing',
            name: 'ViewPricing',
            view: 'application/equipment_pricing/view_pricing',
          },
          {
            path: '',
            name: 'ViewBusinessInfo',
            view: 'application/business/view_business_info',
          },
        ]
      },
    ]
  },
  {
    path: '/application/view/:application_reference',
    view: 'application/view',
    name: 'ApplicationView',
    children: [
      {
        path: 'business_details',
        view: 'application/business/details_index',
        children: [
          {
            path: 'principals',
            name: 'ViewPrincipals',
            view: 'application/principal/view_principal',
          },
          //view_principal can handle bank id now
          // {
          //   path: 'verifyprincipals',
          //   name: 'VerifyPrincipals',
          //   view: 'application/principal/index',
          // },
          // {
          //   path: 'principals/:principal_ref',
          //   name: 'ViewPrincipalAdd',
          //   view: 'application/principal/index',
          // },
          {
            path: 'trading',
            name: 'ViewTrading',
            view: 'application/outlet/view_trading',
          },
          {
            path: '',
            name: 'ViewBusinessDetails',
            view: 'application/business/view_business_details',
          },
        ]
      },
      {
        path: 'documents',
        name: 'ViewDocument',
        view: 'application/document/view',
      },
      {
        path: 'upload_documents',
        name: 'EditDocument',
        view: 'application/document/index',
      },
      {
        path: 'upload_documents_mask',
        name: 'ViewMaskedUploadDocumentMask',
        view: 'application/document/view',
      },
      {
        path: 'documents_mask',
        name: 'ViewMaskedDocumentMask',
        view: 'application/document/view'
      },
      {
        path: 'review',
        view: 'application/review_signature/index',
        children: [
          {
            path: '',
            name: 'ViewReview',
            view: 'application/review_signature/review',
          },
          {
            path: 'signature/:signature_status/:owner_id',
            name: 'ViewSignatureStatus',
            view: 'application/review_signature/review',
          },
          {
            path: 'errors',
            name: 'View Validation Errors',
            view: 'application/review_signature/error',
          }
        ]
      },
    ]
  },
  {
    path: '/application/edit/:application_reference',
    view: 'application/edit',
    name: 'ApplicationEdit',
    children: [
      {
        path: 'business_details',
        name: 'EditBusinessDetail',
        view: 'application/business/details_index',
        children: [
          {
            path: 'principals',
            name: 'Principals',
            view: 'application/principal/index',
          },
          {
            path: 'principals_mask',
            name: 'ViewPrincipalsMaskEdit',
            view: 'application/principal/view_principal',
          },
          {
            path: 'business_details_mask',
            name: 'ViewBusinessDetailsMaskEdit',
            view: 'application/business/view_business_details',
          },
          {
            path: 'principals/:principal_ref',
            name: 'PrincipalAdd',
            view: 'application/principal/index',
          },
          {
            path: 'trading',
            name: 'EditTrading',
            view: 'application/outlet/trading',
          },
          {
            path: '',
            name: 'BusinessDetails',
            view: 'application/business/business_details',
          },
        ]
      },
      {
        path: 'documents',
        name: 'Document',
        view: 'application/document/index',
      },
      {
        path: 'documents_mask',
        name: 'ViewMaskedDocumentEdit',
        view: 'application/document/view'
      },
      {
        path: 'upload_documents_mask',
        name: 'ViewMaskedUploadDocumentEdit',
        view: 'application/document/view',
      },
      {
        path: 'review',
        view: 'application/review_signature/index',
        children: [
          {
            path: '',
            name: 'Review',
            view: 'application/review_signature/review',
          },
          {
            path: 'signature/:signature_status/:owner_id',
            name: 'signatureStatus',
            view: 'application/review_signature/review',
          },
          {
            path: 'errors',
            name: 'Validation Errors',
            view: 'application/review_signature/error',
          }
        ]
      },
        ]
  },
  {
    path: '/application/kreepto',
    view: 'application/bankidverify/index',
  },
  {
    //TODO application/:action/:id/business_info
    // :action can be add/edit/view
    // :id is the id of the application, if there is no :id we can just leave it 0000
    // the system will identify it as a fresh application and still hold
    // the url structure.
    // this way we can reuse paths for any of the 3 actions.

    path: '/application/add',
    // name: 'ApplicationAdd',
    view: 'application/add',
    children: [
      {
        path: 'business',
        view: 'application/business/index',
        children: [
          // {
          //   path: 'principals',
          //   name: 'Principals',
          //   view: 'application/principal/index',
          // },
          // {
          //   path: 'principals/:principal_ref',
          //   name: 'PrincipalAdd',
          //   view: 'application/principal/index',
          // },
          // {
          //   path: 'trading',
          //   name: 'Trading',
          //   view: 'application/outlet/trading',
          // },
          // {
          //   path: 'business_details',
          //   name: 'BusinessDetails',
          //   view: 'application/business/business_details',
          // },
          {
            path: 'products',
            name: 'Edit Equipments',
            view: 'application/equipment_pricing/equipments',
          },
          {
            path: 'pricing',
            name: 'Edit Pricing',
            view: 'application/equipment_pricing/pricing',
          },
          {
            path: '',
            name: 'EditBusinessInfo',
            view: 'application/business/business_info',
          },
        ]
      },
      {
        path: 'business_details',
        view: 'application/business/details_index',
        children: [
          {
            path: 'principals',
            name: 'EditPrincipals',
            view: 'application/principal/index',
          },
          {
            path: 'principals/:principal_ref',
            name: 'EditPrincipalAdd',
            view: 'application/principal/index',
          },
          {
            path: 'trading',
            name: 'Trading',
            view: 'application/outlet/trading',
          },
          {
            path: '',
            name: 'EditBusinessDetails',
            view: 'application/business/business_details',
          },
        ]
      },
      {
        path: 'documents/',
        name: 'Edit Document',
        view: 'application/document/index',
      },
      {
        path: 'review',
        view: 'application/review_signature/index',
        children: [
          {
            path: '',
            name: 'SnapReview',
            view: 'application/review_signature/review',
          },
          {
            path: 'signature/:signature_status/:owner_id',
            name: 'SnapSignatureStatus',
            view: 'application/review_signature/review',
          },
          {
            path: 'errors',
            name: 'Snap Validation Errors',
            view: 'application/review_signature/error',
          }
        ]
      },
      // {
      //   path: 'products',
      //   view: 'application/equipment_pricing/index',
      //   children: [
      //     {
      //       path: '',
      //       name: 'Equipments',
      //       view: 'application/equipment_pricing/equipments',
      //     },
      //     {
      //       path: 'pricing',
      //       name: 'Pricing',
      //       view: 'application/equipment_pricing/pricing',
      //     },
      //   ]
      // },
      // {
      //   path: 'bank_details',
      //   name: 'BankDetails',
      //   view: 'application/bank_details/index',
      // },
      {
        //TODO should redirect if no child is specified in parent
        path: '',
        // component: 'businessInfoParent',
        redirect: '/application/add/business/',
      }
    ]
  },
  // {
  //   path: '/application/edit',
  //   name: 'ApplicationEdit',
  //   view: 'application/edit',
  //   // component: ApplicationEdit,
  // },
  { //TODO this will have to move to a navigation guard.
    path: '/application',
    redirect: '/application/add',
  },
  {
    path: '/applynow/:alliance_code',
    name: 'ApplyNow',
    view: 'applynow/index',
  },
  {
    path: '/applynow/:alliance_code/:entity_type/:entity_id',
    name: '/ApplyNow',
    view: 'applynow/index',
  },
  {
    path: '/',
    name: 'Home',
    view: 'home/index'
  },


]
